'use strict';

function ClientDataController(
    $scope,
    $mdDialog,
    client
) {
    'ngInject';

    $scope.model = client;
    $scope.btnDisabled = true;

    $scope.save = function() {
        if ($scope.form.$valid) {
            $mdDialog.hide();
        }
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default ClientDataController;
